<div class="main-container">
  <div class="grid-container" id="332report-grid-container" style="height: calc(100vh - 124px);">
      <div class="top-toolbar">
          <div class="toolbar-actions">
            @if (taxyearLoaded) {
<ap-dropdown class="tax-year-dropdown" [list]="taxYearItems" [selectType]="'single'" [title]="'Tax Year'" [hideTitleOnInput]="true" [inputAriaLabel]="'Tax Year'" [(ngModel)]="selectedTaxYearItem" (onSelect)="onTaxYearChanged($event)">
  @for (item of taxYearItems; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item" [ariaLabel]="setTaxYearAriaLabel(item)" (onSelectItem)="onTaxYearSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
}
            <gtw-df-me-dropdown class="top-filter-select me-dropdown-label" [customActionCode]="32136"
              (selectedMes)="selectedMeChanged($event)">
            </gtw-df-me-dropdown>
            <ap-button [compact]="true" [btnType]="'primary'" [label]="'Filter'" (onClick)="loadReport()"></ap-button>
            <span class="toolbar-export" (click)="exportToExcel()">
              <span class="Appkit4-icon icon-save-outline"></span>
              <span>Export to Excel</span>
            </span>
          </div>
      </div>

      <div class="dst-mat-grid-layout">
        @if (loading) {
          <div class="dst-mat-grid-loading">
            <mat-spinner [diameter]="40"></mat-spinner>
          </div>
        }
        <div class="dst-mat-grid">
          <table mat-table [dataSource]="dataSource" [fixedLayout]="true" matSort #matSort="matSort"
                 (matSortChange)="onMatSortChange()" class="dst-mat-table">

            <ng-container matColumnDef="STATEMENT_ID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[0])">{{ cols[0].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[0])">
                <a href="javascript:void(0);" (click)="showViewUpdateStatement(rowData)"><span>{{ rowData.STATEMENT_ID }}</span></a>
              </td>
            </ng-container>

            <ng-container matColumnDef="PROJECT_NAME">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[1])">{{ cols[1].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[1])">
                <span>{{ rowData.PROJECT_NAME }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="PRIMARY_LEID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[2])">{{ cols[2].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[2])">
                <span>{{ rowData.PRIMARY_LEID }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="PRIMARY_ENTITY">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[3])">{{ cols[3].header }}</th>
              <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[3])">
                <span>{{ rowData.PRIMARY_ENTITY }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="PRIMARY_BUSINESS">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[4])">{{ cols[4].header }}</th>
              <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[4])">
                <span>{{ rowData.PRIMARY_BUSINESS }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="FILLING_GROUP">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[5])">{{ cols[5].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[5])">
                <span>{{ rowData.FILLING_GROUP }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="SECONDARY_LEID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[6])">{{ cols[6].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[6])">
                <span>{{ rowData.SECONDARY_LEID }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="SECONDARY_ENTITY">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[7])">{{ cols[7].header }}</th>
              <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[7])">
                <span>{{ rowData.SECONDARY_ENTITY }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="LIQUIDATIONDATE_VALUE">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[8])">{{ cols[8].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[8])">
                <span gtwLineSplitter [inputString]="rowData.LIQUIDATIONDATE_VALUE" [sepearator]="'||'" [formatter]="'date'">
                  {{ rowData.LIQUIDATIONDATE_VALUE }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="IMPORTATIONPROPERTYDESC">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[9])">{{ cols[9].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[9])">
                <span>{{ rowData.IMPORTATIONPROPERTYDESC }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="GAINLOSSPROPERTYDESC">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[10])">{{ cols[10].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[10])">
                <span>{{ rowData.GAINLOSSPROPERTYDESC }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="DESCRIPTION">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[11])">{{ cols[11].header }}</th>
              <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[11])">
                <span gtwLineSplitter [inputString]="rowData.DESCRIPTION" [sepearator]="'||'">
                  {{ rowData.DESCRIPTION }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="BASISAMT_VALUE">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[12])">{{ cols[12].header }}</th>
              <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[12])">
                <span gtwLineSplitter [inputString]="rowData.BASISAMT_VALUE" [sepearator]="'||'" [formatter]="'decimal'">
                  {{ rowData.BASISAMT_VALUE }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="BASIS_CURRENCY">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[13])">{{ cols[13].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[13])">
                <span>{{ rowData.BASIS_CURRENCY }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="BASIS_NAME">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[14])">{{ cols[14].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[14])">
                <span gtwLineSplitter [inputString]="rowData.BASIS_NAME" [sepearator]="'||'">
                  {{ rowData.BASIS_NAME }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="FMVAMT_VALUE">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[15])">{{ cols[15].header }}</th>
              <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[15])">
                <span gtwLineSplitter [inputString]="rowData.FMVAMT_VALUE" [sepearator]="'||'" [formatter]="'decimal'">
                  {{ rowData.FMVAMT_VALUE }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="FMV_CURRENCY">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[16])">{{ cols[16].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[16])">
                <span>{{ rowData.FMV_CURRENCY }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="PLR_VALUE">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[17])">{{ cols[17].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[17])">
                <span gtwLineSplitter [inputString]="rowData.PLR_VALUE" [sepearator]="'||'">
                  {{ rowData.PLR_VALUE }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="ADOPTEDDATE_VALUE">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[18])">{{ cols[18].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[18])">
                <span gtwLineSplitter [inputString]="rowData.ADOPTEDDATE_VALUE" [sepearator]="'||'" [formatter]="'date'">
                  {{ rowData.ADOPTEDDATE_VALUE }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="ACQUIREDDATE_VALUE">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[19])">{{ cols[19].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[19])">
                <span gtwLineSplitter [inputString]="rowData.ACQUIREDDATE_VALUE" [sepearator]="'||'" [formatter]="'date'">
                  {{ rowData.ACQUIREDDATE_VALUE }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="EFFECTIVEDATE_VALUE">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[20])">{{ cols[20].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[20])">
                <span>{{ rowData.EFFECTIVEDATE_VALUE | date: 'yyyy-MM-dd' }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="LIQUIDATIONSTATUS">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[21])">{{ cols[21].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[21])">
                <span gtwLineSplitter [inputString]="rowData.LIQUIDATIONSTATUS" [sepearator]="'||'">
                  {{ rowData.LIQUIDATIONSTATUS }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="ADDITIONALTEXT">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[22])">{{ cols[22].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[22])">
                <span>{{ rowData.ADDITIONALTEXT }}</span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" style="height: 45px;"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="height: 70px;"></tr>
          </table>
        </div>
      </div>
  </div>
</div>

@if (showModalViewer) {
<dst-disc-modal-viewer [rowObject]="activeRow" (afterModalClosed)="afterModalClosed()">
</dst-disc-modal-viewer>
}
